export * from './fa-icon.component';
